import { useMemo, useState } from "react";
import useSWR from "swr";
import { getFetcher } from "../../../../../services/api";
import TableFilter from "../../../../elements/TableFilter";
import { month } from "../../../../../enums/month";
import ClientDataGrid from "../../../../elements/ClientDataGrid";
import FilterReactSelect from "../../../../elements/FilterReactSelect";
import ModalDetailPengangkutan from "./ModalDetailPengangkutan";


export default function TableHistoryTransport({ selectedCompany, selectedPeriod, setSelectedPeriod }) {
    // Perusahaan dan periode dioper dari induk supaya pilihan di tab Periode
    // Aktif ikut terbawa ke sini. State lokal hanya dipakai kalau komponen ini
    // dipasang tanpa prop tersebut.
    const [localPeriod, setLocalPeriod] = useState(null);
    const terkendali = typeof setSelectedPeriod === "function";
    const period = terkendali ? selectedPeriod : localPeriod;
    const setPeriod = terkendali ? setSelectedPeriod : setLocalPeriod;

    const { data: dataPeriod, isLoading: isLoadingPeriod } = useSWR(`/api/period/all`, getFetcher);

    // companyId ikut disaring supaya Riwayat menampilkan perusahaan yang sama
    // dengan tab lain. Sebelumnya tab ini menampilkan seluruh perusahaan pada
    // periode tersebut.
    const { data, isLoading } = useSWR(
        period
            ? `/api/pelaporan-pengangkutan/search?returnAll=true&periodId=${period.value}${selectedCompany?.value ? `&companyId=${selectedCompany.value}` : ""}`
            : null, 
        getFetcher
    );
    

    const columns = useMemo(() =>  [
        {
            field: 'company',
            headerName: 'Perusahaan',
            valueGetter: (value, row) => row.company.name
        },
        {
            field: 'vehicle',
            headerName: 'Kendaraan',
            valueGetter: (value, row) => `${row.vehicle.noPolisi} - ${row.vehicle.modelKendaraan}`,
        },
        {
            field: 'bahanB3',
            headerName: 'Bahan B3',
            valueGetter: (value, row)  => 
                row?.pengangkutanDetails
                    ?.map((detail) => detail.dataBahanB3?.namaBahanKimia)
                    ?.filter((nama) => nama)
                    ?.join(', ') || '-',
        },
        {
            field: 'perusahaanAsalMuat',
            headerName: 'Asal Muat',
            valueGetter: (value, row) =>
                row.pengangkutanDetails
                    ?.map((detail) =>
                        detail.DataPerusahaanTujuanBongkarOnPengakutanDetail
                            ?.map((subDetail) => subDetail.perusahaanAsalMuat?.namaPerusahaan)
                            ?.filter((nama) => nama)
                    )
                    .flat()
                    .join(', ') || '-',
        },
        {
            field: 'perusahaanTujuanBongkar',
            headerName: 'Tujuan Bongkar',
            valueGetter: (value, row) =>
                row.pengangkutanDetails
                    ?.map((detail) =>
                        detail.DataPerusahaanTujuanBongkarOnPengakutanDetail
                            ?.map((subDetail) => subDetail.perusahaanTujuanBongkar?.namaPerusahaan)
                            ?.filter((nama) => nama)
                    )
                    .flat()
                    .join(', ') || '-',
        },
        {
            field: 'totalDiangkut',
            headerName: 'Total Diangkut (Kg)',
            valueGetter: (value, row)  =>
                row?.pengangkutanDetails
                    ?.reduce((total, detail) => total + (detail.jumlahB3 || 0), 0) || 0,
        },
        { field: 'period', headerName: 'Periode', valueGetter: (value, row) => row.period.name, },
        { field: 'bulan', headerName: 'Bulan', valueGetter: (value, row) => month[row.bulan-1], },
        { field: 'tahun', headerName: 'Tahun',},
    ], []);
    
    return(
        <div className="h-[550px]">
            <div className='w-full flex justify-end mb-3'>
                <div className="w-1/4">
                    <FilterReactSelect
                        defaultValue={period}
                        placeholder="Cari Periode"
                        options={dataPeriod?.map(item => ({label: item.name, value: item.id}))}
                        isLoading={isLoadingPeriod}
                        setValue={setPeriod}
                    />
                 </div>
            </div>
            <ClientDataGrid
                columns={columns}
                rows={data?.data}
                isLoading={isLoading}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            perusahaanAsalMuat: false,
                            perusahaanTujuanBongkar: false,
                        },
                    },
                }}
            />
        </div>
    )
}

